export class MacroPlaybackClock {
  public static wait(ms: number, signal?: AbortSignal): Promise<void> {
    if (signal?.aborted) return Promise.reject(new Error('Macro cancelled'));
    return new Promise((resolve, reject) => {
      const abort = () => { clearTimeout(timer); reject(new Error('Macro cancelled')); };
      const timer = setTimeout(() => {
        signal?.removeEventListener('abort', abort);
        resolve();
      }, ms);
      signal?.addEventListener('abort', abort, { once: true });
    });
  }
}
